import { useState } from 'react';
import {
  InfoOutlined,
  ExpandMore,
  ExpandLess,
  StorefrontOutlined,
  LocalShippingOutlined,
  BadgeOutlined,
} from '@mui/icons-material';

const ACCENT = '#ff7500';

const USER_TYPES = [
  {
    icon: BadgeOutlined,
    title: 'Operador Soydelivery',
    description:
      'Usuario interno de Soydelivery. Gestiona toda la operación: envíos, rutas, comercios, conductores y operadores.',
  },
  {
    icon: LocalShippingOutlined,
    title: 'Operador Externo',
    description:
      'Usuario de un operador logístico tercerizado. Ve y gestiona solo los envíos de su operador (y sus sub-operadores).',
  },
  {
    icon: StorefrontOutlined,
    title: 'Comercio',
    description:
      'Usuario de un comercio que trabaja con Soydelivery. Ve solo los envíos de su comercio, para seguimiento y reportes.',
  },
];

const UserTypesInfo = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className='overflow-hidden rounded-xl border border-[#ff750033] bg-[#ff75000a]'>
      <button
        type='button'
        onClick={() => setOpen((prev) => !prev)}
        className='flex w-full cursor-pointer items-center justify-between gap-2 px-4 py-2.5 text-left transition-colors hover:bg-[#ff750014]'
        aria-expanded={open}
      >
        <span className='flex items-center gap-2 text-sm font-semibold text-gray-800'>
          <InfoOutlined sx={{ fontSize: 18, color: ACCENT }} />
          ¿Qué tipo de usuario invitar?
        </span>
        {open ? (
          <ExpandLess sx={{ fontSize: 20, color: ACCENT }} />
        ) : (
          <ExpandMore sx={{ fontSize: 20, color: ACCENT }} />
        )}
      </button>

      {open && (
        <div className='grid grid-cols-1 gap-3 border-t border-[#ff750022] bg-white p-4 md:grid-cols-3'>
          {USER_TYPES.map(({ icon: Icon, title, description }) => (
            <div
              key={title}
              className='flex flex-col gap-1.5 rounded-lg border border-gray-100 bg-gray-50/60 p-3'
            >
              <span className='flex items-center gap-2'>
                <span className='flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#ff75001a] text-[#ff7500]'>
                  <Icon sx={{ fontSize: 17 }} />
                </span>
                <span className='text-sm font-semibold text-gray-900'>
                  {title}
                </span>
              </span>
              <span className='text-xs leading-relaxed text-gray-500'>
                {description}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserTypesInfo;
